var _defs, _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDronefriendly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "7.0556mm",
    height: "7.0556mm",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#155196;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Drone Friendly Marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10,20A10,10,0,1,1,20,10,10.0294,10.0294,0,0,1,10,20ZM10,1.1A8.9,8.9,0,1,0,18.9,10,8.92,8.92,0,0,0,10,1.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 10,
    cy: 9.9998,
    r: 8.9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.9,11.3a1.6129,1.6129,0,0,0-.9.3l-.2-.2a2.4015,2.4015,0,0,1,0-2.8l.2-.2a1.6129,1.6129,0,0,0,.9.3,1.6,1.6,0,1,0-1.6-1.6h0a1.6129,1.6129,0,0,0,.3.9l-.2.2a2.4015,2.4015,0,0,1-2.8,0L8.4,8a1.6129,1.6129,0,0,0,.3-.9A1.58,1.58,0,0,0,7.1,5.5,1.5576,1.5576,0,0,0,5.6,7.1,1.6446,1.6446,0,0,0,7.2,8.7h0a1.6129,1.6129,0,0,0,.9-.3l.2.2a2.4015,2.4015,0,0,1,0,2.8l-.3.2a1.6129,1.6129,0,0,0-.9-.3,1.6,1.6,0,1,0,1.6,1.6,1.6129,1.6129,0,0,0-.3-.9l.2-.2a2.4015,2.4015,0,0,1,2.8,0l.2.2a1.6129,1.6129,0,0,0-.3.9,1.6,1.6,0,0,0,3.2,0A1.7181,1.7181,0,0,0,12.9,11.3Zm0-5.2a1.0021,1.0021,0,0,1,1,1,1.0754,1.0754,0,0,1-1,1,4.3311,4.3311,0,0,1-.5-.1l.5-.5.1.1a.2828.2828,0,0,0,.4-.4l-.5-.5a.2828.2828,0,1,0-.4.4h0l.1.1-.6.4a.9015.9015,0,0,1-.1-.5C11.8,6.5,12.3,6.1,12.9,6.1ZM8,7.6l-.5-.5L7.6,7a.2828.2828,0,1,0-.4-.4l-.5.6a.2828.2828,0,0,0,.4.4l.1-.1.4.5a.7638.7638,0,0,1-.5.2,1,1,0,0,1,0-2,1.0754,1.0754,0,0,1,1,1c.1.1,0,.3-.1.4Zm-.9,6.3a1,1,0,0,1,0-2,.7638.7638,0,0,1,.5.2l-.5.5L7,12.4a.2828.2828,0,0,0-.4.4l.5.5a.2828.2828,0,0,0,.4-.4l-.1-.1.6-.4a.9015.9015,0,0,1,.1.5c.1.6-.4,1-1,1Zm5.8,0a1.0021,1.0021,0,0,1-1-1,.7638.7638,0,0,1,.2-.5l.5.5-.2.1a.3042.3042,0,0,0,0,.4h0a.3042.3042,0,0,0,.4,0h0l.5-.5a.2828.2828,0,1,0-.4-.4l-.1.1-.4-.6a.9015.9015,0,0,1,.5-.1,1.0021,1.0021,0,0,1,1,1,.9448.9448,0,0,1-1,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDronefriendly);
export default __webpack_public_path__ + "static/media/dronefriendly.05c76df7ca7a5298ba60d7b442b3e06f.svg";
export { ForwardRef as ReactComponent };